import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[trimValue]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TrimValueDirective),
      multi: true
    }
  ],
  host: {
    '(blur)' : 'trimValue($event.target.value)',
    '(paste)' : 'onPaste($event)'
  }
})
export class TrimValueDirective implements ControlValueAccessor {

  onChange: (_: any) => void;

  constructor(private elementRef: ElementRef<HTMLInputElement>) { }

  writeValue(value: any): void {
    if (value != null) {
      this.elementRef.nativeElement.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {}

  trimValue(value: string) {
    const trimValue = value ? value.trim() : null;
    this.elementRef.nativeElement.value = trimValue;
    this.onChange(trimValue);
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const data = event.clipboardData.getData('text');
    this.trimValue(data);
  }

}
